import {BrowserRouter} from 'react-router';
import RoutesSetup from './routes/RoutesSetup';
import ScrollToTop from 'components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop/>
      <RoutesSetup/>
    </BrowserRouter>
  );
}

export default App;
